module.exports = {
  show_all_news: 'Alle News anzeigen',
  news: 'News',
  all_news: 'Alle News',
}
